import styled from "styled-components";

export const ContainerView = styled.section`
  display: flex;
  /* background-color: #F5F5F6; */
  min-height: 100vh;
  & > :first-child {
    flex: 2;
    min-width: 240px; /* Define the minimum width here */
    max-width: 280px; /* Define the maximum width here */
  }
  & > section {
    flex: 8;
    padding: 0 64px;
    overflow-x: auto;
  }
`;
